(function() {
  const textModule = $('.animateTextModule');
  const descriptionText = $('.animateTextModule__description p');

  $.jScrollability([
    {
      'selector': textModule,
      'start': function($el) { return $el.offset().top + window.innerHeight },
      'end': function($el) { return $el.offset().top + $el.height() },
      'fn': function($el, pcnt) {
        const fullPrcnt = pcnt * 100;

        descriptionText.each(function(i) {
          const opacity = ((pcnt - (i / descriptionText.length)) * ((descriptionText.length - i) + 0.15)) * (i + 1);
          let translate = 0;

          if (pcnt < 1 / descriptionText.length * (i + 1) && pcnt > 1 / descriptionText.length * i) {
            translate = 5 - ((pcnt - 1 / descriptionText.length * i) / (1 / descriptionText.length)) * 5;
          } else if (pcnt < 1 / descriptionText.length * (i + 1)) {
            translate = 5;
          }

          if (fullPrcnt >= ((i / descriptionText.length) * 100) - 15) {
            descriptionText[i].style.opacity = `${Math.min(Math.max(opacity, 0), 1)}`;
            descriptionText[i].style.transform = `translateY(${translate}vh)`;
          } else {
            descriptionText[i].style.opacity = '0';
          }
        });
      }
    }
  ]);
}());
